// The long-form pages, in reading order, with the one-line summary each shows
// when another article recommends it.
//
// This exists because every article now closes on a "Related content" row, and
// the alternative was three hand-written entries per page — six copies of the
// same six descriptions, drifting apart the first time a title changed. Here a
// title is written once and every page that points at it updates.
//
// Order matters: `relatedArticles` walks the list from the current article and
// wraps, so each page recommends a different trio and no article is orphaned.

export const ARTICLES = [
  {
    path: "/case-study/design-system",
    title: "The design system people and AI build every product from",
    description:
      "Every team built interfaces its own way. One foundation of components, tokens, screen recipes and skills became the company’s default way of building frontend.",
  },
  {
    path: "/case-study/ai-workflow",
    title: "Designing how people and AI work together",
    description:
      "A merchant-support workflow where AI prepared the evidence and specialists kept the decision — then the same contract became the base of the company’s AI lifecycle.",
  },
  {
    path: "/case-study/installments",
    title: "Doubling installment revenue by finding the right moment",
    description:
      "A bank app had to double installment revenue in a year. Mapping the payment decision found the moment the roadmap had missed.",
  },
  {
    path: "/case-study/checkout",
    title: "Increasing checkout conversion through systems thinking",
    description:
      "Four reinforcing loops decided whether a payment completed. Each one became a controlled experiment behind a guarded rollout.",
  },
];

// The `count` articles that follow `currentPath` in the list, wrapping around.
// An unknown path (the demo) simply gets the first few.
export function relatedArticles(currentPath, count = 3) {
  const index = ARTICLES.findIndex((article) => article.path === currentPath);
  if (index === -1) return ARTICLES.slice(0, count);
  return Array.from(
    { length: Math.min(count, ARTICLES.length - 1) },
    (_, step) => ARTICLES[(index + step + 1) % ARTICLES.length]
  );
}
